<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item">
        <div class="date-grid">
          <label for="startDatePicker">Created At</label>
          <div class="date-search-container">
            <input
                type="date"
                v-model="formdate"
                class="search-input"
                :max="currentDate"
            />
            <button @click="performSearch" class="btn button-default">Search</button>
          </div>
        </div>
        <button type="button" class="btn button-default new-stock-allocation-btn mt-4" @click="newStockAllocation">
          Create Order Request
        </button>
      </div>

      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr class="border-bottom-primary">
            <th scope="col">Ref no</th>
            <th scope="col">Distributor</th>
            <th scope="col">Created At </th>
            <th scope="col">Destination</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(order, index) in purchaseOrderList"
              :key="index"
          >
            <td>{{ order.refrence_no }}</td>
            <td>{{ order.business_name }}</td>
            <td>{{ order.loading_date_time }}</td>
            <td>{{ order.distributor_location }}</td>
            <td class="mt-1">
              <span :class="getStatusLabelClass(order.status)" v-html="getDispatchStatus(order.status)"></span>
            </td>
            <td>
              <i v-if="order.status === 'pending'" class="fa fa-edit" aria-hidden="true" @click="editDetails(order.id)"></i>
              <i class="fa fa-eye action-icon" aria-hidden="true" @click="showPopupModal(order)"></i>
            </td>
          </tr>
          <tr v-if="!purchaseOrderList || purchaseOrderList.length === 0">
            <td colspan="5" class="text-center">No data available</td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div v-if="showPopup" class="modal">
      <div class="popup-content">
        <div class="popup-header">
          <h3>View Purchase Order</h3>
          <button @click="closePopup" class="close-btn">&times;</button>
        </div>

        <div v-if="loadingPopup" class="loading-spinner">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>
        <div v-else>
          <ul>
            <li><strong>Distributor:</strong> {{ dispatchDetails.distributor }}</li>
            <li><strong>Created At:</strong> {{ dispatchDetails.created_at }}</li>
          </ul>
          <table class="table popup-table">
            <thead>
            <tr>
              <th></th>
              <th>Requested</th>
              <th>Scheduled</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <ul>
                  <li>Loading Time</li>
                  <li>Unloading Time</li>
                  <li>Bridging</li>
                  <li>Bridging Type</li>
                  <li>Vehicle</li>
                  <li>Plant</li>
                  <li>Destination</li>
                  <li>Remarks</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{ dispatchDetails.loading_date_time }}</li>
                  <li>{{ dispatchDetails.unloading_date_time }}</li>
                  <li>{{ dispatchDetails.briding_type }}</li>
                  <li>{{ dispatchDetails.vehicle_type }}</li>
                  <li>{{ dispatchDetails.vehicle }}</li>
                  <li>{{ dispatchDetails.plant }}</li>
                  <li>{{ dispatchDetails.destination }}</li>
                  <li>{{ dispatchDetails.remarks }}</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>{{ dispatchDetails.loading_date_time1 }}</li>
                  <li>{{ dispatchDetails.unloading_date_time1 }}</li>
                  <li>{{ dispatchDetails.briding_type1 }}</li>
                  <li>{{ dispatchDetails.vehicle_type1 }}</li>
                  <li>{{ dispatchDetails.vehicle1 }}</li>
                  <li>{{ dispatchDetails.plant1 }}</li>
                  <li>{{ dispatchDetails.destination1 }}</li>
                  <li>{{ dispatchDetails.remarks1 }}</li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>

          <table class="table popup-table">
            <thead>
            <tr>
              <th>Items</th>
              <th>Requested Qty</th>
              <th>Scheduled Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(items, allocationNo) in stockAllocations" :key="allocationNo">
              <td>{{ items.item_name }}</td>
              <td>{{ parseInt(items.requested_qty) }}</td>
              <td>{{ parseInt(items.scheduled_qty)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, computed } from 'vue';
import { fetchPurchaseOrderList, fetchPurchaseOrderPopup } from '@/services/dataService';

const router = useRouter();
const purchaseOrderList = ref([]);

const profileId = ref(localStorage.getItem('profile_id'));
const token = ref(localStorage.getItem('token_set') || '');

const formdate = ref('');
const initialLoad = ref(true);
const loading = ref(false);
const selectedOrder = ref({});
const orderDetails = ref([]);
const showPopup = ref(false);
const loadingPopup = ref(false);

const dispatchDetails = ref({
  dispatch_no: '',
  created_at: '',
  vehicle: '',
  vehicle1: '',
  vehicle2: '',
  driver: '',
  helper: '',
  rep: '',
  distributor: '',
  route: '',
  stock_allocation_nos: '',
  loading_date_time: '',
  loading_date_time1: '',
  briding_type: '',
  briding_type1: '',
  vehicle_type: '',
  vehicle_type1: '',
  unloading_date_time: '',
  unloading_date_time1: '',
  plant: '',
  plant1: '',
  destination: '',
  destination1: '',
  remarks: '',
  remarks1: ''
});

const stockAllocations = ref([]);

const newStockAllocation = () => {
  router.push({ path: '/order-create' });
};

const getDispatchStatus = (status) => {
  if (status === 'completed') {
    return '<span class="status-completed">Completed</span>';
  } else if (status === 'pending') {
    return '<span class="status-pending">Pending</span>';
  } else if (status === 'rejected') {
    return '<span class="status-rejected">Rejected</span>';
  } else if (status === 'schedule') {
    return '<span class="status-scheduled">Scheduled</span>';
  }
  return '<span class="status-unknown">Unknown</span>';
};

const getStatusLabelClass = (status) => {
  if (status === 'completed') {
    return 'status-completed';
  } else if (status === 'pending') {
    return 'status-pending';
  } else if (status === 'rejected') {
    return 'status-rejected';
  } else if (status === 'schedule') {
    return 'status-scheduled';
  }
  return 'status-unknown';
};

/*const loadPurchaseOrderList = async () => {
  try {
    const response = await fetchPurchaseOrderList(token.value, profileId.value);
    if (response.data.status === 'success') {
      purchaseOrderList.value = response.data.data;
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  }
};
*/
const loadPurchaseOrderList = async () => {
  try {
    const response = await fetchPurchaseOrderList(token.value, profileId.value);
    if (response.data.status === 'success') {
      purchaseOrderList.value = response.data.data;
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  }
};

const filteredPurchaseOrderList = computed(() => {
  if (!formdate.value) return purchaseOrderList.value;
  return purchaseOrderList.value.filter(order => order.loading_date_time === formdate.value);
});

/*const performSearch = async () => {
  //Set Status
  initialLoad.value = false;
  loading.value = true;

  //Reset Data Set before fetch data from API
  purchaseOrderList.value = "";

  try {
    const response = await fetchPurchaseOrderList(token.value, profileId.value, formdate.value);
    if (response.data.status === 'success') {
      purchaseOrderList.value = response.data.data;
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  } finally {
    loading.value = false;
  }
};
*/
const performSearch = async () => {
  //Set Status
  initialLoad.value = false;
  loading.value = true;

  //Reset Data Set before fetch data from API
  purchaseOrderList.value = "";

  try {
    const response = await fetchPurchaseOrderList(token.value, profileId.value, formdate.value);
    if (response.data.status === 'success') {
      purchaseOrderList.value = response.data.data;
    } else {
      console.log(response.data.message);
    }
  } catch (error) {
    console.error("Error fetching purchase order list:", error);
  } finally {
    loading.value = false;
  }
};
const editDetails = (id) => {
  router.push({ path: `/edit-order-request/${id}` });
};

const showPopupModal = async (order) => {
  loadingPopup.value = true;
  showPopup.value = true;
  try {
    const response = await fetchPurchaseOrderPopup(order.id, token.value);
    const purchaseOrder = response.data.data.purchase_order;

    dispatchDetails.value = {
      dispatch_no: purchaseOrder.refrence_no[0],
      created_at: purchaseOrder.created_at[0],
      vehicle: purchaseOrder.vehicle_no[0],
      vehicle1: purchaseOrder.vehicle_no[1], // Assuming driver info is not available in the response
      helper: '', // Assuming helper info is not available in the response
      rep: '', // Assuming rep info is not available in the response
      distributor: purchaseOrder.distributor_name[0],
      route: purchaseOrder.distributor_location[0],
      stock_allocation_nos: purchaseOrder.id[0],
      loading_date_time: purchaseOrder.loading_date_time[0],
      loading_date_time1: purchaseOrder.loading_date_time[1],
      briding_type: purchaseOrder.bridging_name[0],
      briding_type1: purchaseOrder.bridging_name[1],
      vehicle_type: purchaseOrder.vehicle_type[0],
      vehicle_type1: purchaseOrder.vehicle_type[1],
      unloading_date_time: purchaseOrder.unload_date_time[0],
      unloading_date_time1: purchaseOrder.unload_date_time[1],
      plant: purchaseOrder.gas_plant_name[0],
      plant1: purchaseOrder.gas_plant_name[1],
      destination: purchaseOrder.distributor_location[0],
      destination1: purchaseOrder.distributor_location[1],
      remarks: purchaseOrder.remarks[0],
      remarks1: purchaseOrder.remarks[1]
    };
    stockAllocations.value = response.data.data.items;
  } catch (error) {
    console.error("Error fetching purchase order details:", error);
  } finally {
    loadingPopup.value = false;
  }
};

const closePopup = () => {
  showPopup.value = false;
};

const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const currentDate = computed(() => getCurrentDate());

onMounted(async () => {
  try {
    formdate.value = getCurrentDate();
    await loadPurchaseOrderList();
  } catch (error) {
    console.error("Initialization failed:", error);
  }
});
</script>


<style scoped lang="scss">
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.search-input[type="date"] {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  width: 100%;
}

.search-input[type="date"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.search-input[type="date"]:hover {
  border-color: #0056b3;
}

.date-grid {
  display: grid;
  grid-template-rows: auto auto;
  gap: 5px;
  font-weight: bold;
}

.date-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.date-search-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-search-container .search-input {
  flex: 1;
  margin-right: 10px;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.action-icon {
  margin-right: 10px;
}

.new-stock-allocation-btn {
  margin-left: auto;
  padding: 10px 20px;
}

.status-pending {
  background-color: #FFC107; /* Yellow color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;

}

.status-rejected {
  background-color: red; /* Red color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-scheduled {
  background-color: #1B6CB4; /* Blue color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-completed {
  background-color: #069E27; /* Green color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-unknown {
  background-color: grey; /* Grey color */
  color: #FFFFFF; /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-label {
  padding: 5px 10px;
  border-radius: 3px;
  display: inline-block;
}


/* Popup modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 800px;
  max-width: 100%;
  max-height: 80vh; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  transition: color 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}

.popup-table {
  max-height: 300px; /* Adjust the height as needed */
  overflow-y: auto;  /* Enable vertical scrolling */
}
</style>